import StaticListParamsHandler from "./StaticListParamsHandler";

const handler = StaticListParamsHandler(({params, translationManager}) => {
    return translationManager.translate(`$t(logsView.codes.2057)`, params);
});

handler.RegExp = new RegExp(`^2057$`, "g");

export default handler;